import { Component, OnInit } from "@angular/core";
import {
  PostPreviewData,
  WebsiteConfigurationService
} from "../website-configuration/website-configuration.service";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-preview-blog",
  templateUrl: "./preview-blog.component.html",
  styleUrls: ["./preview-blog.component.scss"]
})
export class PreviewBlogComponent implements OnInit {
  previewData: PostPreviewData | null = null;
  content;

  relatedArticles = [
    {
      slug: "ai-in-insurance",
      title: "How AI Is Shaping Insurance",
      date: new Date("2024-11-01"),
      coverImg: "https://via.placeholder.com/180x120"
    },
    {
      slug: "blockchain-claims",
      title: "Blockchain in Claims Processing",
      date: new Date("2024-10-15"),
      coverImg: "https://via.placeholder.com/180x120"
    },
    {
      slug: "data-security-trends",
      title: "Trends in Data Security",
      date: new Date("2024-09-20"),
      coverImg: "https://via.placeholder.com/180x120"
    }
  ];

  constructor(
    private previewService: WebsiteConfigurationService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.previewData = this.previewService.getPreviewData();

    if (this.previewData.content) {
      this.content = this.sanitizer.bypassSecurityTrustHtml(
        this.previewData.content
      );
    }
  }
}
